const getConnectedClientsIsLoading = state => {
  try {
    return state.debtor.connectedClients.loading;
  } catch (err) {
    return false;
  }
};

export default getConnectedClientsIsLoading;
